var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always"}},_vm._l((3),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require('../assets/images/slide/' + item + '.jpg')}})])}),1),_c('h2',[_vm._v("巧于手、智于心")]),_c('h4',[_vm._v("巧手智心STEM欢迎您回来！")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }